// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Um5Po","field":"styles_field__rJJHF","fieldCol":"styles_fieldCol__vEFPd","diffCol":"styles_diffCol__2Ku1E","diff":"styles_diff__2sfXU"};